import createVueApp from '@phoenix/createVueApp';
import SearchPanel from '@maison/components/search/SearchPanel.vue';

const app = createVueApp({}, true);
app.component('SearchPanel', SearchPanel);
app.mount('#phoenix-search-panel');
